import { createSelector } from 'reselect';
import { initialState } from './reducer';

export const key = 'localStorage';

const rootSelector = (state) => {
  if (state && state[key]) {
    return state[key];
  }
  return initialState;
};

export const storedValueSelector = (storageKey) => createSelector(rootSelector, (state) => state[storageKey]);
